import { Reducer } from 'redux';
import { IQueueStoreState, QueueActionTypes } from './types';

export const initialQueueState: IQueueStoreState = {
  sessionId: null,
  queueEmail: null,
  isReadyToBook: false,
  userExist: false,
};

export const queueReducer: Reducer<IQueueStoreState> = (state: IQueueStoreState = initialQueueState, action) => {
  switch (action.type) {
    case QueueActionTypes.APP_READY_TO_BOOK: {
      return { ...state, isReadyToBook: action.payload };
    }
    case QueueActionTypes.SESSION_ID: {
      return { ...state, sessionId: action.payload };
    }
    case QueueActionTypes.EMAIL_QUEUE: {
      return { ...state, queueEmail: action.payload };
    }
    case QueueActionTypes.IS_USER_EXIST: {
      return { ...state, userExist: action.payload };
    }
    default:
      return state;
  }
};
